export default __webpack_public_path__ + "static/media/arrow-right-small-search-select.935451c2.svg";